import {
  canBeOptional,
  checkIsMarkedOptional,
  getFeatureId,
  checkIsFeatureSelected,
} from '../../services';
import { Box, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isFeatureVisible } from '../../services/ClaimsHelper';
import { EVariableType } from '../../data/Constants';
import type { IConfigurationValue, IOptionalControlProps } from '../../../types';

export const OptionalControl = ({
  featureFamily,
  onOptionalChange,
  option,
  disabled,
  featureFlag,
}: IOptionalControlProps) => {
  const { t } = useTranslation();

  const featureOrOptionId = getFeatureId(option?.value, featureFamily);

  function handleChange(e: { target: { checked: boolean } }) {
    if (onOptionalChange) {
      onOptionalChange(featureOrOptionId, e.target.checked, featureFamily);
    }
  }

  if (!isFeatureVisible(featureFlag)) {
    return null;
  }

  const isfeatureOrOptionOptional =
    canBeOptional(featureFamily.properties ?? []) || canBeOptional(option?.properties ?? []);

  if (!isfeatureOrOptionOptional) {
    return <Box className="hyphen"> - </Box>;
  }

  const isNumeric = featureFamily.variableType === EVariableType.Number;

  const isChecked = () => {
    // Numeric: optional state is independent of whether a value is selected (SM1/SM3)
    if (isNumeric) return checkIsMarkedOptional(featureOrOptionId, featureFamily);
    return (
      checkIsMarkedOptional(featureOrOptionId, featureFamily) &&
      !checkIsFeatureSelected(featureOrOptionId, featureFamily)
    );
  };

  const isDisabled = () => {
    // Numeric: never disable because a value exists — only disable for external disabled prop
    if (isNumeric) {
      return (
        !!disabled ||
        featureFamily.values.some((value: IConfigurationValue) => value.assigned === 'ByRule')
      );
    }
    return disabled || checkIsFeatureSelected(featureOrOptionId, featureFamily);
  };

  return (
    <>
      <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>{t('labels.optional')}:&nbsp;</Box>
      <Checkbox
        checked={isChecked()}
        onChange={handleChange}
        disabled={isDisabled()}
        className="paddingTopBottom"
      />
    </>
  );
};
